"use strict";Object.defineProperty(exports, "__esModule", {value: true});


 const isExistingOrgRel = (r) =>
  r && 'SelectedKey' in r; exports.isExistingOrgRel = isExistingOrgRel

 const isSignupPhoneRequired = (
  welcomeUser,
  wasInvitedByPhone,
) => {
  if (wasInvitedByPhone) return false

  const relationships = welcomeUser.Relationships || []
  if (!relationships.length) return true

  return relationships.some(rel => !!rel.MFARequired)
}; exports.isSignupPhoneRequired = isSignupPhoneRequired

 const shouldShowSignupPhone = (wasInvitedByPhone) =>
  !wasInvitedByPhone; exports.shouldShowSignupPhone = shouldShowSignupPhone
